import './css/styles.css';
import { createApp } from 'vue';
import router from '@/routes/index.js';
import App from '@/App.vue';

import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fas,fab)
dom.watch();

createApp(App).use(router).mount('#app');
//window.addEventListener('DOMContentLoaded', event => {

  
//});